import React, { useContext } from 'react';
import classNames from 'classnames';
import { MODALS } from '../../../constants';
import QuoteFormPopUpIcon from '../../../assets/quoteFormPopUpIcon.svg';
import { Context } from '../../../context/AppContext';

import './styles.css';

const QuoteFormButton = () => {
  const {
    media: { desktop, tablet, mobile },
    modal: { showModal, modals },
  } = useContext(Context);

  const modalName = MODALS.QUOTE_FORM;

  const { show } = modals[modalName] || {};

  const animation = `QuoteFormButton${show ? 'Down' : 'Up'}`;

  return (
    <div
      className={classNames('QuoteFormButton__root', {
        'QuoteFormButton__root--desktop': desktop || tablet,
        'QuoteFormButton__root--mobile': mobile,
      })}
    >
      <button
        className="QuoteFormButton__container"
        onClick={() => showModal(modalName)}
        style={{
          animation: `${animation} 300ms cubic-bezier(0.165, 0.07, 0.44, 1) forwards`,
        }}
      >
        <img width="32" src={QuoteFormPopUpIcon} alt="QuoteFormPopUpIcon" />
        {desktop || tablet ? 'Get Quotes' : ''}
      </button>
    </div>
  );
};

export default QuoteFormButton;
